(() => {
  'use strict';

  const stringsElement = document.getElementById('mm-japan-ui-strings');
  if (!stringsElement) return;
  const strings = JSON.parse(stringsElement.textContent);
  let cartQueue = Promise.resolve();

  // API errors can be English even on a Japanese storefront. Keep useful
  // Japanese responses, and translate known stock failures without exposing
  // raw network errors to customers.
  window.MMJapan = {
    // An empty cart can receive competing mutations before Shopify's cart
    // cookie is established. Preserve click order and continue after failures.
    cartRequest(url, options) {
      const next = cartQueue.then(() => fetch(url, options));
      cartQueue = next.catch(() => {});
      return next;
    },
    cartError(message) {
      if (typeof message !== 'string') return strings.cart;
      if (/sold out|not available|unavailable/i.test(message)) return strings.soldOut;
      if (/stock|quantity|only|maximum|limit/i.test(message)) return strings.quantity;
      if (/\b(?:please|cannot|can't|could not|invalid|error|failed|not found|bad request|too many|the product|the variant)\b/i.test(message)) return strings.cart;
      if (/[\u3040-\u30ff\u4e00-\u9fff]/u.test(message)) return message;
      return strings.cart;
    },
  };

  // Browser validation normally follows the visitor's browser language.
  // Use Japanese text while preserving native validation and submission.
  const isField = (field) => field instanceof HTMLInputElement ||
    field instanceof HTMLTextAreaElement || field instanceof HTMLSelectElement;

  document.addEventListener('invalid', (event) => {
    const field = event.target;
    if (!isField(field)) return;
    field.setCustomValidity('');
    const validity = field.validity;
    if (validity.valueMissing) field.setCustomValidity(field.matches('[data-mm-newsletter-consent]') ? strings.newsletterConsent : strings.required);
    else if (validity.typeMismatch && field.type === 'email') field.setCustomValidity(strings.email);
    else if (validity.rangeUnderflow || validity.rangeOverflow || validity.stepMismatch || validity.badInput) {
      field.setCustomValidity(strings.number);
    } else if (!validity.valid) field.setCustomValidity(strings.invalid);
  }, true);

  const clearValidation = (event) => {
    if (isField(event.target)) event.target.setCustomValidity('');
  };
  document.addEventListener('input', clearValidation);
  document.addEventListener('change', clearValidation);
})();
